module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/chevronRight.58d80b3a.svg";